<script>
	import { userid } from '../utils';
	import { getConfig, saveConfig, listConfigs, deleteConfig } from '../configUtils.js';
	const urlParams = new URLSearchParams(window.location.search);
	const client = urlParams.get('client');
	let createDialog, deleteDialog, newLabel, selectedConfig;

	let listConfigsLocal = listConfigs($userid, client);

	async function createNewLabel() {
		let base = await getConfig(
			$userid,
			client,
			selectedConfig.config_type,
			selectedConfig.config_label,
			null
		);
		if (base) {
			base.config_label = newLabel;
			let msg = await saveConfig($userid, client, selectedConfig.config_type, newLabel, base);
			listConfigsLocal = listConfigs($userid, client);
			selectedConfig = {};
			createDialog.close();
			alert(msg.detail);
		}
	}
	async function deleteLabel() {
		console.log('delete');
		let msg = await deleteConfig(
			$userid,
			client,
			selectedConfig.config_type,
			selectedConfig.config_label,
			selectedConfig.source_config_type
		);
		listConfigsLocal = listConfigs($userid, client);

		selectedConfig = {};
		deleteDialog.close();
		alert(msg.detail);
	}
</script>

{#await listConfigsLocal}
	loading....
{:then configs}
	<div class="scrl">
		<table align="left">
			<thead>
				<th>Config Type</th>
				<th>Config Label</th>
				<th>Config Source</th>
				<th>Action</th>
			</thead>
			<tbody>
				{#each configs as config}
					<tr>
						<td>
							<a
								href="?client={client}&config_type={config.config_type}&config_label={config.config_label}&source_config_type={config.source_config_type}#edit"
							>
								{config.config_type}
							</a>
						</td>
						<td>
							<a
								href="?client={client}&config_type={config.config_type}&config_label={config.config_label}&source_config_type={config.source_config_type}#edit"
							>
								{config.config_label}
							</a>
						</td>
						<td>{config?.source_config_type || ''}</td>
						<td
							><button
								on:click={() => {
									createDialog.showModal();
									selectedConfig = config;
								}}>add label</button
							>
							{#if config.config_label != 'default'}
								<button
									class="delete-btn"
									on:click={() => {
										deleteDialog.showModal();
										selectedConfig = config;
									}}>delete label</button
								>
							{/if}
						</td>
					</tr>
				{/each}
			</tbody>
		</table>
	</div>
{:catch error}
	{error}
{/await}

<dialog bind:this={createDialog} on:close>
	{#if selectedConfig}
		<h2>Add {selectedConfig?.config_type} label</h2>
		<input type="text" bind:value={newLabel} name="config label" placeholder="Label Name" />
		<button on:click={() => createNewLabel()}>Create label</button>
	{/if}
</dialog>
<dialog bind:this={deleteDialog} on:close>
	{#if selectedConfig}
		<h2>Delete {selectedConfig?.config_label} for {selectedConfig?.config_type}</h2>
		<button class="delete-btn" on:click={() => deleteLabel()}> Delete </button>
	{/if}
</dialog>

<style>
	table {
		width: 100%;
		border-collapse: collapse;
		color: #000;
	}
	tr,
	thead,
	tbody {
		border-bottom: 1px solid #000;
	}

	tr:nth-child(2n) {
		background-color: rgba(25, 25, 25, 0.08);
	}

	th,
	td {
		padding: 0.5em;
		text-align: left;
	}
	td,
	th {
		border-right: 1px solid #000;
	}

	thead {
		position: sticky;
		top: 0;
		background-color: #fff;
		z-index: 2;
	}

	.scrl {
		overflow-y: scroll;
		max-height: 500px;
		position: relative;
		border-radius: 12px;
		border: 1px solid #000;
	}
	button {
		background-color: #bafca2;
		border: 1px solid #000;
		border-radius: 8px;
		font-size: 14px;
		padding: 2px 8px;
	}
	.delete-btn {
		background-color: #ff6b6b;
		color: #000;
	}

	input {
		padding: 1em;
		width: 100%;
		border: 1px solid #000;
		margin: 0em 0 1em;
		border-radius: 12px;
	}
	dialog {
		margin: auto;
		padding: 1em;
		border-radius: 12px;
		border: 1px solid #000;
	}
	dialog h2 {
		margin-bottom: 0.5em;
	}

	dialog > button {
		width: 100%;
		padding: 1em;
	}
</style>
